import { IObservable, Subject } from '~/rage/utils';
import { CharacterLicense } from '~/shared';
import {
	IDrivingSchoolExam,
	IDrivingSchoolService,
} from './drivingSchoolServiceTypes';

export class DrivingSchoolServiceStub implements IDrivingSchoolService {
	private exams = new Subject<IDrivingSchoolExam[]>([
		{
			id: CharacterLicense.DrivingCar,
			name: 'Driving Car',
			letter: 'A',
			price: 1000,
			isOwned: false,
		},
		{
			id: CharacterLicense.DrivingBike,
			name: 'Driving Bike',
			letter: 'B',
			price: 1000,
			isOwned: false,
		},
	]);

	public fetchExams(): void {
		console.log('fetchExams');
	}

	public getExams(): IObservable<IDrivingSchoolExam[]> {
		return this.exams;
	}

	public async startExam(licenseId: CharacterLicense): Promise<void> {
		console.log('drivingSchool:startExam', { licenseId });
	}

	public async exit(): Promise<void> {
		console.log('drivingSchool:exit');
	}
}
